import { render, staticRenderFns } from "./ShowList.vue?vue&type=template&id=484ead40&scoped=true&lang=html&"
import script from "./ShowList.vue?vue&type=script&lang=js&"
export * from "./ShowList.vue?vue&type=script&lang=js&"
import style0 from "./ShowList.vue?vue&type=style&index=0&id=484ead40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ead40",
  null
  
)

export default component.exports